import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import OtpInput from 'react-otp-input';
import { Box, Grid, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getOtp } from 'redux/actions/authAction';
import { companyDetails } from 'utils/companyDetails';
import Timer from './Timer';

function Otp(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userOtp = useSelector((state) => state);
  const isLoader = userOtp?.auth?.otpLoader;
  const mobile = localStorage.getItem('mobile');
  const otpSecret = localStorage.getItem('secretToken');
  const otpSuccess = userOtp?.auth?.isAuth;
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const [errorOtp, setErrorOtp] = useState('');
  const [autoFocusOtp, setAutoFocusOtp] = useState(true);

  const resetOtp = () => {
    reset();
    setErrorOtp('');
  }

  const onSubmit = (data) => {
    const mobile = localStorage.getItem('mobile');
    const otpDetails = {
      platform: 'AdminApp',
      mobileOrEmail: mobile,
      otp: data,
      otpSecret: otpSecret,
      countryCode: '+91',
    };
    dispatch(getOtp(otpDetails, navigate, {resetOtp: resetOtp, setAutoFocusOtp: setAutoFocusOtp}));
  };

  const onBackBtn = () => {
    localStorage.clear();
    props?.onOtpPage(false);
  };

  // ---Check Wheather mobile is present or not----
  useEffect(() => {
    const mobile = localStorage.getItem('mobile');
    if (!mobile) {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    if (isLoader) {
      setAutoFocusOtp(false);
    }
  }, [isLoader]);

  const handleOtpChange = (value) => {
    const validateNumber = /^\d+$/.test(value); // Check if value contains only digits

    if (!validateNumber) {
      setErrorOtp('OTP must contain only numbers');
    } else if (value.length === 4) {
      setErrorOtp(''); // Clear error message if the length is correct and contains only numbers
      onSubmit(value);
    } else {
      setErrorOtp(`OTP must be 4 characters long`);
    }
  };

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
        <Grid container spacing={2} className="">
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
              alignItems={'center'}
              sx={{ display: { xs: 'none', sm: 'flex' } }}
              className="positionAbsolute otpLogo ml40"
            >
              <ArrowBackIcon
                onClick={() => {
                  onBackBtn();
                }}
              />
              <img src={companyDetails?.companyLogo} className="maxWidth" alt="otplogo" />
            </Box>

            {/* ---OTP input type--- */}
            <div className="loginInput mobileBg">
              <Grid container className="justifyCenter" rowSpacing={4}>
                <Grid item sm={8} className="textCenter">
                  <div>
                    <h1 className="fontBold font36 colorPrimary m0">
                      Enter your <span className="colorYellow">OTP</span>
                    </h1>
                    <p className="colorGrey font16 fontNormal m0">
                      An authentication {companyDetails?.companyName} code has been sent to
                    </p>
                    <Typography variant={'body2'} className="colorGrey fw600">
                      {mobile}
                    </Typography>
                  </div>
                </Grid>
                <Grid item sm={8}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    {/* ---OTP UI--- */}
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item sm={8} className="otpInput">
                        <Controller
                          name="otp"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: 'OTP is required',
                            minLength: {
                              value: 4,
                              message: 'OTP must be 4 characters long',
                            },
                          }}
                          render={({ field }) => (
                            <OtpInput
                              containerStyle="otp"
                              inputStyle={
                                errors.otp ? 'otpStyleError' : 'otpStyle'
                              }
                              value={field.value}
                              inputType="tel"
                              onChange={(value) => {
                                field.onChange(value);
                                handleOtpChange(value);
                              }}
                              numInputs={4}
                              renderInput={(props) => (
                                <input {...props} disabled={isLoader} />
                              )}
                              shouldAutoFocus={autoFocusOtp}
                            />
                          )}
                        />
                        {errorOtp && (
                          <p className="errorOtp justifyCenter">
                            <span>
                              <ErrorIcon />
                            </span>
                            {errorOtp}
                          </p>
                        )}
                      </Grid>
                      <Grid
                        container
                        item
                        sm={8}
                        justifyContent="center"
                        className="otpInput"
                      >
                        {/* ---Timer Screen--- */}
                        <Grid item>
                          <div>
                            <Timer onResend={resetOtp} setAutoFocusOtp={setAutoFocusOtp} />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <div className="otpName"></div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Otp;
